import React, { useEffect, useState, useRef } from 'react'
import { IoLogoJavascript } from "react-icons/io5";
import { SiMongodb } from "react-icons/si";
import { IoLogoFirebase } from "react-icons/io5";
import { FaPython } from "react-icons/fa";
import { FaReact } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa6";
import { FaGithubSquare } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";

import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards, Mousewheel, Pagination, Keyboard, Autoplay } from 'swiper/modules';
import "swiper/css"
import "swiper/css/effect-cards"
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/mousewheel';

const Images=[
  "/photos/Image1.png",
  "/photos/Image3.png",
  "/photos/Image2.png",
]

const SkillsCards = [
  {name:"JavaScript",icon:IoLogoJavascript, image:false},
  {name:"React Native",icon:FaReact, image:false},
  {name:"React",icon:FaReact, image:false},
  {name:"Python",icon:FaPython, image:false},
  {name:"NextJs",icon:`${process.env.PUBLIC_URL}/photos/Next.png`, image:true},
  {name:"Node Js",icon:`${process.env.PUBLIC_URL}/photos/Node.png`, image:true},
  {name:"TypeScript",icon:`${process.env.PUBLIC_URL}/photos/TS.png`, image:true},
  {name:"Tailwind CSS",icon:`${process.env.PUBLIC_URL}/photos/Tailwind.png`, image:true},
  {name:"HTML",icon:`${process.env.PUBLIC_URL}/photos/HTML.png`, image:true},
]

const cloudSkills=[
  {name:"AWS",icon:`${process.env.PUBLIC_URL}/photos/aws.png`, image:true},
  {name:"Render",icon:`${process.env.PUBLIC_URL}/photos/render.png`, image:true},
  {name:"Railway",icon:`${process.env.PUBLIC_URL}/photos/Railway.png`, image:true},
  {name:"Hostinger",icon:`${process.env.PUBLIC_URL}/photos/Hostinger.png`, image:true},
  {name:"Vercel",icon:`${process.env.PUBLIC_URL}/photos/Vercel.png`, image:true}, 
]

const ToolsSkills=[
  {name:"Git",icon:`${process.env.PUBLIC_URL}/photos/git.png`, image:true},
  {name:"Postman",icon:`${process.env.PUBLIC_URL}/photos/Postman.png`, image:true},
]

const DBskills=[
  {name:"Firebase",icon:IoLogoFirebase, image:false},
  {name:"MongoDB",icon:SiMongodb, image:false},
]


const experiences = [
  {
    company: "UpTye/EV Enterprise",
    designation: "Software Engineer",
    location: "Camac Street, Kolkata",
    duration: "02/2025 - Present",
    responsibilities: [
      "Served as Full Stack Developer and Project Manager for Flyberg, an AI-powered itinerary builder for a Singapore-based client, owning feature planning, delivery, and regular client meetings to align on progress and roadmap priorities.",
      "Automated city-level location data collection via Python scripts, reducing per-city processing time from 1 week (manual) to 4-5 hours, a 95% reduction across 300 cities.",
      "Improved development workflows, helping reduce feature delivery timelines and increase team efficiency.",
      "Mentored a junior developer on the team's end-to-end software development process, from planning through deployment.",
      "Streamlined Flyberg's feature set by identifying and removing low-impact, cost-inefficient functionality, accelerating product growth and reducing infrastructure overhead.",
      "Working as a Full Stack Developer (frontend, API, and backend integrations) on Aethex.ai, a UK-based client project."
    ],
    status:true,
  },
  {
    company: "Ardent Computech Pvt. Ltd",
    designation: "Internship in MERN Stack",
    location: "Sector V, Kolkata",
    duration: "06/2024 – 08/2024",
    responsibilities: [
      "Gained hands-on experience in full-stack web development using the MERN stack (MongoDB, Express.js, React, and Node.js).",
      "Automated city-level location data collection via Python scripts, reducing per-city processing time from 1 week (manual) to 4-5 hours, a 95% reduction across 300 cities.",
      " Built fully functional web applications with responsive user interfaces and backend API integration.",
      " Collaborated with mentors and team members to improve debugging, development practices, and deployment workflows"
    ],
    status:false,
  }
];

const projects = [
  {
    id: 1,
    projectName: "Flyberg",
    description: "AI-powered travel itinerary builder for personalized trip planning.",
    role: "Project Manager & Full Stack Developer",
    techStack: ["Next.js", "Tailwind CSS", "MongoDB", "Python", "Google Maps API"],
    links: {
      live: "https://flyberg.com",
      github: null
    },
    type:"web"
  },
  {
    id: 2,
    projectName: "PM Enterprise Business Website",
    description: "Freelance project local business",
    role: "Freelance Full Stack Developer",
    techStack: ["React", "Node.js", "REST API", "Tailwind CSS"],
    links: {
      live: "https://www.weightkart.in/",
      github: null
    },
    type:"web"
  },
  {
    id: 3,
    projectName: "Matrim Milk",
    description: "Online milk delivery platform.",
    role: "Full Stack Developer",
    techStack: ["React Native", "Node.js", "Firebase", "Express.js"],
    links: {
      live: "https://play.google.com/store/apps/details?id=com.matrimmilk&pcampaignid=web_share",
      github: null
    },
    type:"app"
  },
  {
    id: 4,
    projectName: "Portfolio Website",
    description: "My Portfolio",
    role: "Full Stack Developer",
    techStack: ["React","Node.js"],
    links: {
      live: "https://sudip4262.github.io/Portfolio/",
      github: "https://github.com/Sudip4262/Portfolio.git"
    },
    type:"web"
  },
  {
    id: 5,
    projectName: "Cravings",
    description: "Online food ordering platform with customer and admin applications.",
    role: "Full Stack Developer",
    techStack: ["React", "React Native", "Firebase", "Node.js"],
    links: {
      live: null,
      github: "https://github.com/Sudip4262/Cravings.git"
    },
    type:"web"
  },
];

const education=[
  {
    name:"Amity University Kolkata",
    course:"Master of Computer Application",
    location:"Kolkata",
    year:"2023-2025"   
  },
  {
    name:"Gour Mahavidyalaya",
    course:"B.Sc Computer Science",
    location:"Sector V",
    year:"2020-2023"
  }
]

export default function HomePage() {
  
  const time = new Date()
  let hour = time.getHours()
  console.log(time)

  const isMd = window.innerWidth >= 768;

  const[scrollY, setScrollY] = useState(false)
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });
  

  useEffect(() => {
    // alert(window.innerWidth)
    window.scrollTo({
      top: 0,
      left: document.body.scrollWidth,
      behavior: "instant",
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
      console.log(window.scrollY)
    }

    window.addEventListener("scroll",handleScroll)

    return() => {
      window.removeEventListener("scroll", handleScroll)
    }
  },[])

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async() => {

    //   web3forms accesskey
    //   "3f677c58-9f04-4a9b-900b-9bc5f14b9661"

    if (formData.firstName == '' || formData.email == '' || formData.phone == '') {
      alert("Please enter First Name, email and Phone.")
      return
    }

    const response = await fetch(
      "https://api.web3forms.com/submit",
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          access_key:"3f677c58-9f04-4a9b-900b-9bc5f14b9661",
          subject: "🚀 Enquiry on Portfolio Page",
          from_name: "Portfolio Page",

          firstName:formData.firstName,
          lastName:formData.lastName,
          email:formData.email,
          phone:formData.phone,
          message:formData.message
        })
      }
    )

    const data = await response.json();

    if(data.success) {
      alert("Message sent!");
      setFormData({
        firstName:'',
        lastName:'',
        email:'',
        phone:'',
        message:''
      })
    } else{
      alert("Something went wrong. please try again")
    }
  }



  return (
    <div className='flex flex-col min-h-screen w-full bg-white overflow-hidden'>

    {/* Hero section */}
      <div className='flex flex-col md:flex-row md:min-h-screen w-full mt-32 md:mt-10 '>
        <div className='flex flex-[1] md:flex-[3] justify-center items-center'>
          <div className='flex flex-col w-[90%] ml-0 md:ml-10 '>
            <p className='text-2xl md:text-4xl font-bold leading-none mb-6'>A little bit <br/> <p className='text-4xl md:text-5xl'>about me</p></p>
            <p className='text-sm md:text-lg leading-normal text-justify'>
              Full Stack Developer (MERN) with some years of experience delivering web and mobile applications for international clients. I specialize in React, React Native, Next.js, Node.js, and MongoDB, building products that combine performance, scalability, and exceptional user experiences.
            </p>
            <br/>
            <p className='text-sm md:text-lg leading-normal text-justify'>
              From intuitive frontends to scalable backend systems, I enjoy turning ideas into reliable digital products that create real value.</p>
          </div>
        </div>
        <div className='flex flex-[1] md:flex-[2] justify-center md:items-center mt-8 md:mt-0'>
          <div className='flex flex-col h-[200px] w-[175px] md:h-[400px] md:w-[300px]'>
            <Swiper
              effect='cards'
              grabCursor={true}
              autoplay={{
                delay:2000,
                disableOnInteraction:false
              }}
              modules={[EffectCards, Autoplay]}
              cardsEffect={{
                perSlideOffset:20,
                perSlideRotate:4,
                slideShadows:false
              }}
              className='h-full w-full'
              >
              {
                Images.map((img) => (
                  <SwiperSlide key={img} className=' h-full w-full'>
                    <img
                      src={`${process.env.PUBLIC_URL}/${img}`}
                      className='h-full w-full object-cover rounded-xl'
                    />
                  </SwiperSlide>
                ))
              }
            </Swiper>
          </div>
        </div>
      </div>

      <div className='flex flex-col relative w-full items-center '>
        <div className='flex '>
          <p
            className="transition-all duration-300 text-2xl md:text-4xl font-bold"
            style={
              isMd
                ? {
                    opacity: Math.min(Math.max((scrollY - 200) / 150, 0), 1),
                    transform: `translateY(${
                      0 - Math.min(Math.max((scrollY - 200) / 150, 0), 1) * 50
                    }px)`,
                  }
                : {
                  opacity: Math.min(Math.max((scrollY - 120) / 100, 0), 1),
                  transform: `translateY(${
                    100 - Math.min(Math.max((scrollY - 120) / 100, 0), 1) * 50
                  }px)`
                }
            }>
            Focusing on the Skills
          </p>
        </div>
        <div className='flex w-[100vw] md:w-[60vw] h-[35vh] md:h-[25vw] border-b-2 m-4 md:mt-10'
          style={
              isMd
                ? {
                    opacity: Math.min(Math.max((scrollY - 250) / 150, 0), 1),
                    transform: `translateY(${
                      0 - Math.min(Math.max((scrollY - 250) / 150, 0), 1) * 50
                    }px)`,
                  }
                : {
                  opacity: Math.min(Math.max((scrollY - 200) / 100, 0), 1),
                  transform: `translateY(${
                    110 - Math.min(Math.max((scrollY - 200) / 100, 0), 1) * 50
                  }px)`
                }
            }>
          <Swiper
            direction='vertical'
            slidesPerView={1}
            spaceBetween={20}
            loop={true}
            speed={700}
            mousewheel={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction:false,
            }}
            keyboard={{
              enabled:true
            }}
            pagination={{
              clickable:true,
            }}
            modules={[Mousewheel, Pagination, Keyboard, Autoplay]}
            className='skills-swiper'
            >
            <SwiperSlide className=''>
              <div className='flex flex-col flex-wrap p-4 justify-center items-center'>
                <p className=' text-xs md:text-lg font-semibold rounded-[10px] px-4 py-1 border-2 border-[#ffd119]'>Fullstack Skills</p>
                <div className='flex flex-[2] flex-row flex-wrap gap-2 md:gap-4 p-4 justify-center items-center'>
                  {
                    SkillsCards.map((item) => {
                      const Icon = item.icon
                      return(
                        <div className='flex flex-row justify-center items-center border-[1px] gap-2 border-[#ffd119] rounded-[10px]'>
                          {
                            item.image? <img src={Icon} className='w-[15px] md:w-[25px] my-1 ml-1 md:ml-4'/>
                            : <Icon size={isMd? 25 : 15} className='my-1 ml-1 md:ml-4'/>
                          }
                          <p className='text-black text-sm md:text-lg pr-2 md:pr-4 '>{item.name}</p>
                        </div>
                      )
                    })
                  }
                </div>
                <p className='text-xs md:text-lg font-semibold rounded-[10px] px-4 py-1 border-2 border-[#ffd119]'>Database</p>
                <div className='flex flex-[2] flex-row flex-wrap gap-2 md:gap-4 p-4 justify-center items-center'>
                  {
                    DBskills.map((item) => {
                      const Icon = item.icon
                      return(
                        <div className='flex flex-row justify-center items-center border-[1px] gap-2 border-[#ffd119] rounded-[10px]'>
                          {
                            item.image? <img src={Icon} className='w-[15px] md:w-[25px] my-1 ml-1 md:ml-4'/>
                            : <Icon size={isMd? 25 : 15} className='my-1 ml-1 md:ml-4'/>
                          }
                          <p className='text-black text-sm md:text-lg pr-2 md:pr-4 '>{item.name}</p>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide className='bg-blue'>
              <div className='flex flex-col flex-wrap p-4 justify-center items-center'>
                <p className='text-xs md:text-lg font-semibold rounded-[10px] px-4 py-1 border-2 border-[#ffd119]'>Cloud Skills</p>
                <div className='flex flex-[2] flex-row flex-wrap gap-2 md:gap-4 p-4 justify-center items-center'>
                  {
                    cloudSkills.map((item) => {
                      const Icon = item.icon
                      return(
                        <div className='flex flex-row justify-center items-center border-[1px] gap-2 border-[#ffd119] rounded-[10px]'>
                          {
                            item.image? <img src={Icon} className='w-[15px] md:w-[25px] my-1 ml-1 md:ml-4'/>
                            : <Icon size={isMd? 25 : 15} className='my-1 ml-1 md:ml-4'/>
                          }
                          <p className='text-black text-sm md:text-lg pr-2 md:pr-4  '>{item.name}</p>
                        </div>
                      )
                    })
                  }
                </div>
                <p className='text-xs md:text-lg font-semibold rounded-[10px] px-4 py-1 border-2 border-[#ffd119]'>Tools</p>
                <div className='flex flex-[2] flex-row flex-wrap gap-2 md:gap-4 p-4 justify-center items-center'>
                  {
                    ToolsSkills.map((item) => {
                      const Icon = item.icon
                      return(
                        <div className='flex flex-row justify-center items-center border-[1px] gap-2 border-[#ffd119] rounded-[10px]'>
                          {
                            item.image? <img src={Icon} className='w-[15px] md:w-[25px] my-1 ml-1 md:ml-4'/>
                            : <Icon size={isMd? 25 : 15} className='my-1 ml-1 md:ml-4'/>
                          }
                          <p className='text-black text-sm md:text-lg pr-2 md:pr-4'>{item.name}</p>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>

      <div className='flex flex-col relative w-[80vw] self-center items-center mt-[120px] md:mt-10'>
        <div className='flex flex-col h-full w-full items-center'>
          <p
            className="transition-all duration-300 text-2xl md:text-4xl font-bold "
            style={
              isMd
                ? {
                    opacity: Math.min(Math.max((scrollY - 550) / 150, 0), 1),
                    transform: `translateY(${
                      20 - Math.min(Math.max((scrollY - 550) / 150, 0), 1) * 50
                    }px)`,
                  }
                : {
                  opacity: Math.min(Math.max((scrollY - 400) / 100, 0), 1),
                  transform: `translateY(${
                    20 - Math.min(Math.max((scrollY - 400) / 100, 0), 1) * 50
                  }px)`
                }
            }>
            Experience
          </p>
          <div className='flex h-full w-full flex-col gap-2'
            style={
              isMd
                ? {
                    opacity: Math.min(Math.max((scrollY - 700) / 150, 0), 1),
                    transform: `translateY(${
                      20 - Math.min(Math.max((scrollY - 700) / 150, 0), 1) * 50
                    }px)`,
                  }
                : {
                  opacity: Math.min(Math.max((scrollY - 500) / 100, 0), 1),
                  transform: `translateY(${
                    20 - Math.min(Math.max((scrollY - 500) / 100, 0), 1) * 50
                  }px)`
                }
            }>
            {
              experiences.map((item) => (
                <div className='flex relative flex-col my-12 gap-2'>
                  {/* Top Left Corner */}
                  <div className="absolute w-60 md:w-100 h-28 border-t-[2px] border-l-[2px] border-[#ffd119] top-0 left-0 m-[-30px]" />

                  <div className='flex flex-row justify-between items-center'>
                    <p className='flex items-center text-base md:text-2xl text-[#000] font-bold gap-2'>{item.company} 
                      {
                        item.status? 
                        <span className="hidden md:flex flex-row items-center justify-center rounded-full bg-[#1f1]/20 px-2 ml-2">
                          <span className="h-2 w-2 rounded-full bg-[#00bf00] m-2"></span>
                          <span className="text-xs text-[#00bf00] font-normal mr-2"> current</span>
                        </span>
                        :
                        <div></div>
                      }
                    </p>
                    <p className='text-xs md:text-base text-[#000] font-'>{item.location}</p>
                  </div>
                  <div className='flex flex-row justify-between items-center'>
                    <p className='text-sm md:text-xl text-[#000] font-semibold '>{item.designation}</p>
                    <p className='text-xs md:text-base text-[#000] font-'>{item.duration}</p>
                  </div>
                  <div>
                    {
                      item.responsibilities.map((items) => (
                        <div className='flex flex-row gap-4'>
                          <div className='flex h-2 w-2 rounded-full bg-[#000] mt-2'></div>
                          <p className='text-[#000] text-xs md:text-base'>{items}</p>
                        </div>
                      ))
                    }
                  </div>

                  {/* Bottom Right Corner */}
                  <div className="absolute w-60 md:w-100 h-28 border-b-[2px] border-r-[2px] border-[#ffd119] m-[-30px] bottom-0 right-0" />
                </div>
              ))
            }
          </div>
        </div>
      </div>
      
      <div className='flex flex-col relative min-h-screen w-[90vw] self-center items-center md:mt-[40px]'>
        <div className='flex flex-col h-full w-full items-center'>
          <p
            className="transition-all duration-300 text-2xl md:text-4xl font-bold "
            style={
              isMd
                ? {
                    opacity: Math.min(Math.max((scrollY - 1400) / 150, 0), 1),
                    transform: `translateY(${
                      30 - Math.min(Math.max((scrollY - 1400) / 150, 0), 1) * 50
                    }px)`,
                  }
                : {
                  opacity: Math.min(Math.max((scrollY - 1330) / 100, 0), 1),
                  transform: `translateY(${
                    40 - Math.min(Math.max((scrollY - 1330) / 100, 0), 1) * 50
                  }px)`
                }
            }>
            Projects
          </p>
        </div>
        <div className='flex relative flex-row flex-wrap w-full justify-center ' 
        style={
              isMd
                ? {
                    opacity: Math.min(Math.max((scrollY - 1450) / 150, 0), 1),
                    transform: `translateY(${
                      60 - Math.min(Math.max((scrollY - 1450) / 150, 0), 1) * 50
                    }px)`,
                  }
                : {
                  opacity: Math.min(Math.max((scrollY - 1420) / 100, 0), 1),
                  transform: `translateY(${
                    50 - Math.min(Math.max((scrollY - 1420) / 100, 0), 1) * 50
                  }px)`
                }
            }>
          {
            projects.map((item) => (
              <div className='flex flex-col relative w-[90%] md:w-[32%] border m-2 bg-[#383838] p-4 rounded-[10px] '>
                <p className='text-base md:text-lg text-[#FFF] font-semibold'>{item.projectName}</p>
                <p className='text-sm text-[#FFF] '>{item.role}</p>
                <p className='text-xs text-[#FFF] mb-4'>({item.description})</p>
                <p className='flex flex-row flex-wrap text-xs md:text-sm text-[#FFF] gap-2 items-center '>Tech Stack: 
                {
                  item.techStack.map((item) => (
                    <p className='text-xs font-semibold text-[#FFF] px-2 py-1 rounded-[10px] border border-[#00bf00]'>{item}</p>
                  ))
                }
                </p>
                <div className='flex flex-row mt-4 gap-2'>
                  <img src={`${process.env.PUBLIC_URL}/photos/git.png`} alt="github" className={item.links.github? 'w-8 cursor-pointer hover:scale-[1.1] duration-300':'w-0'} onClick={() => {window.open(item.links.github, "_blank")}} />
                  <img src={`${process.env.PUBLIC_URL}/photos/Link.png`} alt="github" className={item.links.live? 'w-8 bg-[#FFF] rounded-[4px] cursor-pointer hover:scale-[1.1] duration-300':'w-0'} onClick={() => {window.open(item.links.live, "_blank")}}/>
                </div>
                <p className='absolute top-0 right-0 text-xs text-[#00bf00] px-2 md:px-4 py-1 bg-[#00bf00]/20 rounded-[4px] border border-[#00bf00] m-2 md:m-4'>{item.type}</p>
              </div>
            ))
          }
        </div>
      </div>
      <div className='flex flex-col relative  w-[80vw] self-center items-center mt-10'>
        <div className='flex flex-col h-full w-full items-center'>
          <p
            className="transition-all duration-300 text-2xl md:text-4xl font-bold "
            style={
              isMd
                ? {
                    opacity: Math.min(Math.max((scrollY - 2050) / 150, 0), 1),
                    transform: `translateY(${
                      0 - Math.min(Math.max((scrollY - 2050) / 150, 0), 1) * 50
                    }px)`,
                  }
                : {
                  opacity: Math.min(Math.max((scrollY - 2550) / 100, 0), 1),
                  transform: `translateY(${
                    40 - Math.min(Math.max((scrollY - 2550) / 100, 0), 1) * 50
                  }px)`
                }
            }>
            Education
          </p>
          <div className='flex h-full w-full flex-col gap-2'
            style={
              isMd
                ? {
                    opacity: Math.min(Math.max((scrollY - 2100) / 150, 0), 1),
                    transform: `translateY(${
                      20 - Math.min(Math.max((scrollY - 2100) / 150, 0), 1) * 50
                    }px)`,
                  }
                : {
                  opacity: Math.min(Math.max((scrollY - 2650) / 100, 0), 1),
                  transform: `translateY(${
                    40 - Math.min(Math.max((scrollY - 2650) / 100, 0), 1) * 50
                  }px)`
                }
            }>
            {
              education.map((item) => (
                <div className='flex relative flex-col my-12 gap-2'>
                  {/* Top Left Corner */}
                  <div className="absolute w-80 h-12 border-t-[2px] border-l-[2px] border-[#ffd119] m-[-30px]" />

                  <div className='flex flex-row justify-between items-center'>
                    <p className='text-base md:text-xl text-[#000] font-semibold '>{item.name}</p>
                    <p className='text-sm md:text-base text-[#000] '>{item.location}</p>
                  </div>
                  <div className='flex flex-row justify-between items-center'>
                    <p className='text-xs md:text-sm text-[#000] font-semibold '>{item.course}</p>
                    <p className='text-xs md:text-sm text-[#000] '>{item.year}</p>
                  </div>

                  {/* Bottom Right Corner */}
                  <div className="absolute w-80 h-12 border-b-[2px] border-r-[2px] border-[#ffd119] m-[-30px] bottom-0 right-0" />
                </div>
              ))
            }
          </div>
        </div>
      </div>

      <div id='contact'></div>

      <div className='flex flex-col w-full justify-center items-center gap-16 mt-12 md:my-12'>
          <p
            className="transition-all duration-300 text-2xl md:text-4xl font-bold "
            style={
              isMd
                ? {
                    opacity: Math.min(Math.max((scrollY - 2500) / 150, 0), 1),
                    transform: `translateY(${
                      40 - Math.min(Math.max((scrollY - 2500) / 150, 0), 1) * 50
                    }px)`,
                  }
                : {
                  opacity: Math.min(Math.max((scrollY - 2950) / 100, 0), 1),
                  transform: `translateY(${
                    40 - Math.min(Math.max((scrollY - 2950) / 100, 0), 1) * 50
                  }px)`
                }
            }>
            Get in Touch
          </p>
        <div className='flex flex-col md:flex-row w-[85%]'
        style={
              isMd
                ? {
                    opacity: Math.min(Math.max((scrollY - 2550) / 150, 0), 1),
                    transform: `translateY(${
                      20 - Math.min(Math.max((scrollY - 2550) / 150, 0), 1) * 50
                    }px)`,
                  }
                : {
                  opacity: Math.min(Math.max((scrollY - 3000) / 100, 0), 1),
                  transform: `translateY(${
                    0 - Math.min(Math.max((scrollY - 3000) / 100, 0), 1) * 50
                  }px)`
                }
            }>
          {/* LEFT */}
          <div className='flex-[1.5] flex flex-col justify-center'>
            <p className='text-lg text-[#666] mb-2'>
              Let's get in touch to
            </p>

            <h2 className='text-3xl md:text-6xl font-bold leading-tight'>
              <span className='text-[#111]'>build something</span>
              <span className='text-[#ffd119]'> great</span>
              <br />
              <span className='text-[#111]'>Togather</span>
            </h2>

            <p className='text-[#666] mt-6 text-base md:text-lg max-w-[450px]'>
              Have a project in mind or just want to say hello?
              I'd love to hear from you.
            </p>

            <div className='flex gap-2 mt-4 md:mt-8 mb-4 md:mb-0'>
              <a href='https://www.linkedin.com/in/sudip4262/' target='_blank'>
                <FaLinkedin
                  size={60}
                  className='p-2 bg-white rounded-xl shadow-md cursor-pointer hover:-translate-y-1 duration-300'
                  color='#ffd119'
                />
              </a>

              <a href='https://github.com/Sudip4262' target='_blank'>
              <FaGithubSquare
                size={60}
                className='p-2 bg-white rounded-xl shadow-md cursor-pointer hover:-translate-y-1 duration-300'
                color='#ffd119'
              />
              </a>

              <a href='https://www.instagram.com/_finding_errors?igsi=Ymh1ZzYzN3dtYXBz&utm_source=qr' target='_blank'>
              <FaSquareInstagram
                size={60}
                className='p-2 bg-white rounded-xl shadow-md cursor-pointer hover:-translate-y-1 duration-300'
                color='#ffd119'
              />
              </a>
            </div>
          </div>

          {/* RIGHT */}
          <div className='flex-[1]'>
            <div className='bg-white p-4 md:p-8 rounded-[24px] shadow-[0_20px_60px_rgba(0,0,0,0.08)] border border-[#ffd119] md:border-[#FFF]'>

              <div className='grid grid-cols-2 gap-2 md:gap-4'>
                <input
                  type='text'
                  name='firstName'
                  placeholder='First Name'
                  className='w-full px-5 py-2 md:py-4 rounded-xl border border-[#ffd119]/40 focus:border-[#ffd119] focus:outline-none'
                  value={formData.firstName}
                  onChange={handleChange}
                />
                <input
                  type='text'
                  name='lastName'
                  placeholder='Last Name'
                  className='w-full px-5 py-2 md:py-4 rounded-xl border border-[#ffd119]/40 focus:border-[#ffd119] focus:outline-none'
                  value={formData.lastName}
                  onChange={handleChange}
                />

                <input
                  type='email'
                  name='email'
                  placeholder='Email'
                  className='w-full px-5 py-2 md:py-4 rounded-xl border border-[#ffd119]/40 focus:border-[#ffd119] focus:outline-none'
                  value={formData.email}
                  onChange={handleChange}
                />

                <input
                  type='tel'
                  name='phone'
                  placeholder='Phone'
                  className='w-full px-5 py-2 md:py-4 rounded-xl border border-[#ffd119]/40 focus:border-[#ffd119] focus:outline-none'
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <textarea
                rows={3}
                name='message'
                placeholder='Tell me about your project...'
                className='w-full mt-4 px-5 py-2 md:py-4 rounded-xl border border-[#ffd119]/40 focus:border-[#ffd119] focus:outline-none resize-none'
                value={formData.message}
                onChange={handleChange}
              />

              <button
                onClick={handleSubmit}
                className='w-full mt-6 py-2 md:py-4 rounded-xl bg-[#ffd119] active:bg-[#ffd119]/50 text-black font-semibold hover:scale-[1.03] duration-300 shadow-lg'
              >
                Send Message
              </button>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}



